
export default function(api: GlobalFetch) {
  return async function(values) {
    const response = await api.fetch(
      `/api/v2/booking/map`,
      {
        body: JSON.stringify(values),
        method: 'POST',
      },
    )

    if (response.ok) {
      return true
    } else {
      throw new Error(response.status.toString())
    }
  }
}
